export const getContactFromEvent = (event: any, connection: any) => {
  const user = connection.contact?.uri["user"]
  const from = event.response.from.uri.user
  const received_host = event.response["via"]["received"]
  const rport = event.response["via"]["rport"]
  const host = event.response["via"]["host"]
  return `PJSIP/${from}/sip:${user}@${received_host}:${rport};transport=ws;x-ast-orig-host=${host}:0`
}
